import { HttpEventType, HttpResponse } from "@angular/common/http";
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Globals } from "../../../../globals/Globals";
import { HttpService } from "../../../../services/http.service";
import { ShareService } from "../../../../services/share.service";
import { StyleService } from "../../../../services/style.service";
import { TabsComponent } from "./tabs.component";

declare let $: any;
declare let require: any;
const sortable = require("html5sortable");

@Component({
  selector: "app-dynamic-template",
  templateUrl: "./dynamic.html",
  styleUrls: ["./pop-over.scss"]
})
export class DynamicTemplateComponent implements OnInit, AfterViewInit {
  static currItemId = "";
  static currItemTag = "";
  static currViewID = "";
  contentTypes = [
    { label: "Image", value: "img" },
    { label: "IFrame", value: "iframe" },
    { label: "Video", value: "video" }
  ];
  iframeLink: any;
  selectedType: any;
  serverUrl = Globals.SERVER_ADDR;
  cpImages: any;
  itemTag: any;
  progress: { percentage: number } = { percentage: 0 };
  elemClickLeft: string;
  middleFamily: any;
  middleBorderRadius: any;
  middleBorderColor: any;
  middleBorderWidth: any;
  middleBackground: any;
  middleWidth: any;
  videoLink: any;
  video = false;
  middleColor: any;
  middleFontSize: any;
  middleFontWeight: any;
  dndSort: any;
  viewableClass: Boolean = false;
  eventTarget: any;
  elemClickHeight: string;
  selectedSize;
  selectedFont;
  selectedFontWeight;
  selectedBorder;
  selectedBorderRadius;
  selectedBorderColor = "#ffffff";
  selectedInputColor = "#ffffff";
  selectedShadowColor = "#ffffff";
  selectedFontSize: any;
  eventVariable;
  isSaved;
  isPagesRendered = false;

  isDisabled = false;
  selectedTextShadow;
  isInput = false;
  isLabel = false;
  isButton = false;
  isParagraph = false;
  isImage = false;
  isVideo = false;
  isIframe = false;
  // isLoadingImage = false;

  borderWidth = this.styleService.borderWidth;
  borderRadius = this.styleService.borderRadius;
  shadowOpts = this.styleService.shadowOpts;
  fontWeight = this.styleService.fontWeight;
  sizeOpts = this.styleService.sizeOpts;
  fontSize = this.styleService.fontSize;

  @Input() selectedTemplateHTML;
  @Input() templateName;
  @Input() templateIDInfo;
  @Input() templateData;
  @Input() allPages;
  @Input() itemViewId;
  @Input() backgroundColor;
  @Input() backgroundImage;
  @Input() allFonts;

  @ViewChild("dynamicId") elementRoot: ElementRef;
  @ViewChild("popOver") popOver: ElementRef;
  @ViewChild(TabsComponent) tabsComponent;

  @Output() percentage = new EventEmitter();
  @Output() isLoadingImage = new EventEmitter();
  @Output() changePageType = new EventEmitter();

  autoPlayVideo: any[] = [{ name: "Yes" }, { name: "No" }];
  autoPlayVideoParam;

  constructor(
    private shareService: ShareService,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private styleService: StyleService,
    private uploadService: HttpService
  ) {
    this.isSaved = false;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.popOver.nativeElement.style.left = this.elemClickLeft;
    this.popOver.nativeElement.style.top = this.elemClickHeight;
  }

  ngOnInit() {
    this.selectedTemplateHTML = this.sanitizer.bypassSecurityTrustHtml(
      this.selectedTemplateHTML
    );
    this.isPagesRendered = true;
    this.shareService.sendTabsState(this.isPagesRendered);
    const allPages = $(".parentBlock").find("a");

    for (let i = 0; i < allPages.length; i++) {
      allPages[i].style.pointerEvents = "none";
    }
    // get api
    // this.uploadService
    //   .get(Globals.SERVER_ADDR + "/cp/fonts/getAll")
    //   .subscribe((data: any) => {
    //     this.allFonts = data.payload;
    //     this.fontOpts.forEach(f => this.allFonts.push({ fileName: f.name }));
    //     console.log(this.allFonts);
    //     console.log(this.fontOpts);
    //   });
    // get api
  }

  ngAfterViewInit() {
    const sortablePlaceholder = `width: 100%; border: 1px dashed gainsboro !important;
                                     height: 35px; border-radius: 5px; margin-bottom: 5px;`;
    this.dndSort = sortable(".sortable", {
      refreshPositions: true,
      placeholder: `<div style="${sortablePlaceholder}"></div>`,
      forcePlaceholderSize: true
    });
    this.renderer.listen(this.elementRoot.nativeElement, "click", evt => {
      this.hasClass(evt.target, "viewable");
      if (evt.offsetX !== 0) {
        this.isInput = false;
        this.isLabel = false;
        this.isButton = false;
        this.isParagraph = false;
        this.isImage = false;
        this.isVideo = false;
        this.isIframe = false;
      }
      if (this.viewableClass) {
        console.log("CLICKED", evt);
        switch (evt.target.tagName) {
          case "P":
            // console.log("P");
            this.isParagraph = true;
            break;
          case "LABEL":
            // console.log("LABEL");
            this.isLabel = true;
            break;
          case "VIDEO":
            this.popOver.nativeElement.style.width = "20%";
            evt.target.onclick = evt.target.play();
            evt.target.muted = true;
            this.itemTag = "splashImage";
            this.videoLink = evt.target.currentSrc;
            this.selectedType = "video";
            DynamicTemplateComponent.currItemId = evt.target.getAttribute("id");
            DynamicTemplateComponent.currViewID = this.itemViewId;
            DynamicTemplateComponent.currItemTag = this.itemTag;
            this.isVideo = true;
            break;
          case "DIV":
            console.log("IFRAME", evt.target.parentNode.children[1].src);
            this.popOver.nativeElement.style.width = "20%";

            this.itemTag = "splashImage";
            this.iframeLink = evt.target.parentNode.children[1].src;
            this.selectedType = "iframe";
            DynamicTemplateComponent.currItemId = evt.target.getAttribute("id");
            DynamicTemplateComponent.currViewID = this.itemViewId;
            DynamicTemplateComponent.currItemTag = this.itemTag;
            this.isIframe = true;
            break;
          case "IMG":
            // console.log("IMG");
            this.popOver.nativeElement.style.width = "20%";
            this.selectedType = "img";
            if (evt.target.getAttribute("id") === "logo_id") {
              this.itemTag = "logo";
            } else if (
              evt.target.getAttribute("id") === "login_image_id_1" ||
              evt.target.getAttribute("id") === "login_image_id_2" ||
              evt.target.getAttribute("id") === "content_image"
            ) {
              this.itemTag = "splashImage";
            } else if (evt.target.getAttribute("id") === "ad_img_id_1") {
              this.itemTag = "adImgId1";
            } else if (evt.target.getAttribute("id") === "ad_img_id_2") {
              this.itemTag = "adImgId2";
            } else if (evt.target.getAttribute("id") === "ad_img_id_3") {
              this.itemTag = "adImgId3";
            } else if (evt.target.getAttribute("id") === "ad_img_id_4") {
              this.itemTag = "adImgId4";
            } else if (evt.target.getAttribute("id") === "ad_img_id_5") {
              this.itemTag = "adImgId5";
            } else if (evt.target.getAttribute("id") === "ad_img_id_6") {
              this.itemTag = "adImgId6";
            }
            DynamicTemplateComponent.currItemId = evt.target.getAttribute("id");
            DynamicTemplateComponent.currItemTag = this.itemTag;
            DynamicTemplateComponent.currViewID = this.itemViewId;
            this.isImage = true;
            // document.getElementById("imageFile").click();
            break;
          case "BUTTON":
            // console.log("BUTTON");
            this.isButton = true;
            break;
          case "INPUT":
            // console.log("INPUT");
            this.isInput = true;
            switch (evt.target.type) {
              case "email":
                // console.log("email");
                break;
              case "password":
                // console.log("password");
                break;
              case "text":
                // console.log("text");
                break;
              case "tel":
                // console.log("tel");
                break;
            }
            break;
        }
        this.popOver.nativeElement.style.display = "flex";
        if (this.isIframe) {
          this.elemClickHeight =
            evt.target.offsetParent.offsetParent.offsetTop +
            evt.target.offsetTop +
            evt.target.offsetParent.offsetTop +
            evt.target.offsetHeight +
            9 +
            "px";
          this.elemClickLeft =
            evt.target.offsetParent.offsetParent.offsetLeft +
            evt.target.offsetLeft +
            evt.target.offsetParent.offsetLeft +
            "px";
        } else if (evt.target.offsetParent) {
          this.elemClickHeight =
            evt.target.offsetTop +
            evt.target.offsetParent.offsetTop +
            evt.target.offsetHeight +
            9 +
            "px";
          this.elemClickLeft =
            evt.target.offsetLeft + evt.target.offsetParent.offsetLeft + "px";
        } else {
          this.elemClickHeight =
            evt.target.offsetTop + evt.target.offsetHeight + 9 + "px";
          this.elemClickLeft = evt.target.offsetLeft + "px";
        }
        this.eventTarget = evt.target;
        this.eventVariable = evt.target.style;
        this.popOver.nativeElement.style.left = this.elemClickLeft;
        this.popOver.nativeElement.style.top = this.elemClickHeight;

        // font family
        if (this.eventVariable.fontFamily) {
          // console.log(this.eventVariable.fontFamily);
          for (let i = 0; i < this.allFonts.length; i++) {
            // console.log(this.fontOpts[i]);
            if (this.allFonts[i].fileName === this.eventVariable.fontFamily) {
              this.selectedFont = this.allFonts[i];
            }
          }
        } else {
          this.selectedFont = this.allFonts[0];
        }
        // font weight
        if (this.eventVariable.fontWeight) {
          for (let i = 0; i < this.fontWeight.length; i++) {
            if (
              this.fontWeight[i].value === Number(this.eventVariable.fontWeight)
            ) {
              this.selectedFontWeight = this.fontWeight[i];
            }
          }
        } else {
          this.selectedFontWeight = this.fontWeight[0];
        }
        // background color
        this.backgroundColor = this.eventVariable.backgroundColor;
        this.backgroundImage = this.eventVariable.backgroundImage;
        // border color
        if (this.eventVariable.borderColor) {
          this.selectedBorderColor = this.eventVariable.borderColor;
        } else {
          this.selectedBorderColor = "#ffffff";
        }
        if (this.eventVariable.color) {
          this.selectedInputColor = this.eventVariable.color;
        } else {
          this.selectedInputColor = "#ffffff";
        }
        // shadow color
        if (this.eventVariable.textShadow.split(")").length > 1) {
          this.selectedShadowColor =
            this.eventVariable.textShadow.split(")")[0] + ")";
        } else {
          this.selectedShadowColor = "#ffffff";
        }
        // border
        if (this.eventVariable.borderWidth) {
          switch (this.eventVariable.borderWidth) {
            case "1px":
              this.selectedBorder = this.borderWidth[0];
              break;
            case "2px":
              this.selectedBorder = this.borderWidth[1];
              break;
            case "3px":
              this.selectedBorder = this.borderWidth[2];
              break;
          }
        } else {
          this.selectedBorder = this.borderWidth[0];
        }
        // border radius
        if (this.eventVariable.borderRadius) {
          switch (this.eventVariable.borderRadius) {
            case "3px":
              this.selectedBorderRadius = this.borderRadius[2];
              break;
            case "5px":
              this.selectedBorderRadius = this.borderRadius[1];
              break;
            case "10px":
              this.selectedBorderRadius = this.borderRadius[0];
              break;
          }
        } else {
          this.selectedBorderRadius = this.borderRadius[0];
        }
        // text shadow
        if (this.eventVariable.textShadow) {
          let textSwitch;
          if (this.eventVariable.textShadow.split(") ").length > 1) {
            textSwitch = this.eventVariable.textShadow.split(") ")[1];
          } else {
            textSwitch = this.eventVariable.textShadow;
          }
          // console.log(textSwitch);
          switch (textSwitch) {
            case "0px -2px 5px":
              this.selectedTextShadow = this.shadowOpts[0];
              break;
            case "0px -2px 10px":
              this.selectedTextShadow = this.shadowOpts[1];
              break;
            case "2px 0px 5px":
              this.selectedTextShadow = this.shadowOpts[2];
              break;
            case "2px 0px 10px":
              this.selectedTextShadow = this.shadowOpts[3];
              break;
            case "-2px 0px 5px":
              this.selectedTextShadow = this.shadowOpts[4];
              break;
            case "-2px 0px 10px":
              this.selectedTextShadow = this.shadowOpts[5];
              break;
            case "0px 2px 5px":
              this.selectedTextShadow = this.shadowOpts[6];
              break;
            case "0px 2px 10px":
              this.selectedTextShadow = this.shadowOpts[7];
              break;
          }
        } else {
          this.selectedTextShadow = this.shadowOpts[8];
        }
        // size
        if (this.eventVariable.width) {
          switch (this.eventVariable.width) {
            case "31.3%":
              this.selectedSize = this.sizeOpts[2];
              break;
            case "48%":
              this.selectedSize = this.sizeOpts[1];
              break;
            case "100%":
              this.selectedSize = this.sizeOpts[0];
              break;
          }
        } else {
          this.selectedSize = this.sizeOpts[0];
        }
        // font size
        if (this.eventVariable.fontSize) {
          // console.log(this.eventVariable.fontSize);
          switch (this.eventVariable.fontSize) {
            case "10px":
              this.selectedFontSize = this.fontSize[0];
              break;
            case "11px":
              this.selectedFontSize = this.fontSize[1];
              break;
            case "12px":
              this.selectedFontSize = this.fontSize[2];
              break;
            case "13px":
              this.selectedFontSize = this.fontSize[3];
              break;
            case "14px":
              this.selectedFontSize = this.fontSize[4];
              break;
            case "15px":
              this.selectedFontSize = this.fontSize[5];
              break;
            case "16px":
              this.selectedFontSize = this.fontSize[6];
              break;
            case "17px":
              this.selectedFontSize = this.fontSize[7];
              break;
            case "18px":
              this.selectedFontSize = this.fontSize[8];
              break;
            case "19px":
              this.selectedFontSize = this.fontSize[9];
              break;
            case "20px":
              this.selectedFontSize = this.fontSize[10];
              break;
          }
        } else {
          this.selectedFontSize = this.fontSize[1];
        }
        this.viewableClass = false;
        this.middleColor = this.eventVariable.color;
        this.middleBorderColor = this.eventVariable.borderColor;
        this.middleBackground = this.eventVariable.background;
      } else {
        this.popOver.nativeElement.style.display = "none";
      }
      if (this.isImage) {
        // this.closePopover();
      }
    });
    for (let i = 0; i < this.dndSort.length; i++) {
      this.renderer.listen(this.dndSort[i], "sortstart", e => {
        this.closePopover();
      });
    }
  }

  hasClass(target, cls) {
    if ((" " + target.className + " ").indexOf(" " + cls + " ") > -1) {
      return (this.viewableClass = true);
    } else if (
      (" " + target.parentElement.className + " ").indexOf(" " + cls + " ") > -1
    ) {
      return (this.viewableClass = true);
    }
  }
  onUrlSubmit() {
    let tag;
    if (this.isImage) {
      tag = "image";
      this.changePageType.emit(true);
    } else if (this.isIframe) {
      tag = "iframe";
      this.changePageType.emit(true);
    } else {
      tag = "video";
    }
    $("#" + this.itemViewId + " #login_" + tag + "_id_1").replaceWith(
      $(
        `<video width="100%" height="auto" style="margin-bottom: -5px" id="login_video_id_1" class="viewable" controls> <source src="${
          this.videoLink
        }" type="video/mp4" crossorigin autoplay> Your OS does not support the video tag. </video>`
      )
    );
    $("#" + this.itemViewId + " #login_" + tag + "_id_2").replaceWith(
      $(
        `<video width="100%" height="auto" style="margin-bottom: -5px" id="login_video_id_2" class="viewable" controls> <source src="${
          this.videoLink
        }" type="video/mp4" crossorigin autoplay> Your OS does not support the video tag. </video>`
      )
    );
  }
  onIframeSubmit() {
    let tag;
    if (this.isImage) {
      tag = "image";
      this.changePageType.emit(true);
    } else if (this.isVideo) {
      tag = "video";
      this.changePageType.emit(true);
    } else {
      tag = "iframe";
    }
    $("#" + this.itemViewId + " #login_" + tag + "_id_1").replaceWith(
      $(
        `<div id="login_iframe_id_1" style="position: relative; margin-top: -1px; margin-left: -1px; margin-bottom: -5px"><div id="remove_id_1" style="position: absolute; top: 0; left: 0; width: 100%; height: 400px" class="viewable"></div><iframe src="${
          this.iframeLink
        }" width="100%" scrolling="yes" height="400px"></iframe></div>`
      )
    );
    $("#" + this.itemViewId + " #login_" + tag + "_id_2").replaceWith(
      $(
        `<div id="login_iframe_id_2" style="position: relative; margin: auto"><div id="remove_id_2" style="position: absolute; top: 0; left: 0; width: 100%; height: 400px" class="viewable"></div><iframe src="${
          this.iframeLink
        }" width="100%" scrolling="yes" height="400px"></iframe></div>`
      )
    );
  }
  uploadImage() {
    document.getElementById("imageFile").click();
  }
  upload(e) {
    // console.log("upload");
    if (this.isVideo) {
      $("#" + this.itemViewId + " #login_video_id_1").replaceWith(
        $(`<img id="login_image_id_1" class="main-content-image viewable">`)
      );
      $("#" + this.itemViewId + " #login_video_id_2").replaceWith(
        $(`<img id="login_image_id_2" class="main-content-image viewable">`)
      );
      DynamicTemplateComponent.currItemId =
        "login_image_id_1, #login_image_id_2";
      this.changePageType.emit(false);
    } else if (this.isIframe) {
      $("#" + this.itemViewId + " #login_iframe_id_1").replaceWith(
        $(`<img id="login_iframe_id_1" class="main-content-image viewable">`)
      );
      $("#" + this.itemViewId + " #login_iframe_id_2").replaceWith(
        $(`<img id="login_iframe_id_2" class="main-content-image viewable">`)
      );
      DynamicTemplateComponent.currItemId =
        "login_image_id_1, #login_image_id_2";
      this.changePageType.emit(false);
    }
    this.isLoadingImage.emit(true);
    
    this.uploadService
      .pushFileToStorage(
        e,
        this.templateData.id,
        DynamicTemplateComponent.currViewID,
        DynamicTemplateComponent.currItemTag
      )
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progress.percentage = Math.round(
            (100 * event.loaded) / event.total
          );
          this.percentage.emit(this.progress.percentage);
          setTimeout(() => {
            this.isLoadingImage.emit(false);
            this.progress.percentage = 0;
          }, 2000);
        } else if (event instanceof HttpResponse) {
          this.getPicture();
        }
      });
  }

  getPicture() {
    this.uploadService
      .getFiles(
        DynamicTemplateComponent.currViewID,
        DynamicTemplateComponent.currItemTag,
        this.templateData.id
      )
      .subscribe(data => {
        this.cpImages = data.payload.img;
        if (this.itemViewId === "login") {
          for (
            let i = 0;
            i <
            document.querySelectorAll("#" + DynamicTemplateComponent.currItemId)
              .length;
            i++
          ) {
            document
              .querySelectorAll("#" + DynamicTemplateComponent.currItemId)
              [i].setAttribute(
                "src",
                "data:image/JPEG;base64," + `${this.cpImages}`
              );
          }
        } else {
          this.eventTarget.setAttribute(
            "src",
            "data:image/JPEG;base64," + `${this.cpImages}`
          );
        }
      });
  }

  setAutoPlay(e) {
    var tag = document.getElementById("content_video") as any;
    tag.autoplay = this.autoPlayVideoParam.name === "Yes";
    tag.load();
  }

  setUrl(e) {
    if (this.isVideo) {
      var tag = document.getElementById("content_video") as any;
      tag.setAttribute("src", e.target.value);
    }
    if (this.isIframe) {
      var tag = document.getElementById("content_iframe") as any;
      tag.setAttribute("src", e.target.value);
    }
  }

  changeSize(e) {
    this.middleWidth = e.originalEvent.target.style.width;
    this.eventVariable.width = e.value.value + "%";
  }

  changeFontFamily(e) {
    this.middleFamily = this.eventVariable.fontFamily;
    this.eventVariable.fontFamily = e.value.fileName;
    this.searchForFontFamily(e.value);
  }
  searchForFontFamily(font) {
    let coreFont = false;
    this.styleService.fontOpts.forEach(fontOpt => {
      if (fontOpt.name === font.fileName) {
        coreFont = true;
      }
    });
    if (coreFont) {
      return;
    }
    let styleTag = document.querySelector("#" + this.itemViewId + " .style");
    if (!styleTag) {
      const addStyle: any = document.querySelector(
        "#" + this.itemViewId + " #cp"
      );
      addStyle.innerHTML += '<style class="style"></style>';
      styleTag = document.querySelector("#" + this.itemViewId + " .style");
    }
    const search = styleTag.innerHTML.search(font.fileName);
    if (search === -1) {
      styleTag.innerHTML += `@font-face {font-family: "${
        font.fileName
      }";src: url("${
        font.fontUrl
      }") format("woff2"),url("${
        font.fontUrl
      }") format("woff");}`;
    }
  }
  changeFontWeight(e) {
    this.middleFontWeight = this.eventVariable.fontWeight;
    this.eventVariable.fontWeight = e.value.value;
  }

  changeFontSize(e) {
    this.middleFontSize = this.eventVariable.fontSize;
    this.eventVariable.fontSize = e.value.value + "px";
  }

  changeBorder(e) {
    this.middleBorderWidth = this.eventVariable.borderWidth;
    this.eventVariable.borderWidth = e.value.value + "px";
    this.eventVariable.borderStyle = "solid";
  }

  changeBorderRadius(e) {
    this.middleBorderRadius = this.eventVariable.borderRadius;
    this.eventVariable.borderRadius = e.value.value + "px";
  }

  changeShadow(e) {
    if (e.value.value === "") {
      this.eventVariable.textShadow = e.value.value;
    } else if (this.eventVariable.textShadow.split(")").length > 1) {
      const shadow = this.eventVariable.textShadow.split(")");
      shadow[1] = e.value.value;
      this.eventVariable.textShadow = shadow[0] + ") " + shadow[1];
    } else {
      this.eventVariable.textShadow = e.value.value;
    }
  }

  changeShadowColor(e) {
    if (this.eventVariable.textShadow.split(")").length > 1) {
      const shadow = this.eventVariable.textShadow.split(")");
      shadow[0] = e;
      this.eventVariable.textShadow = shadow[0] + " " + shadow[1];
    } else {
      this.eventVariable.textShadow = e + " " + this.eventVariable.textShadow;
    }
  }

  changeBackgroundColor(e) {
    this.eventVariable.background = e;
  }

  changeInputColor(e) {
    this.eventVariable.color = e;
  }

  changeBorderColor(e) {
    this.eventVariable.borderColor = e;
  }

  onReset() {
    this.eventVariable.textShadow = "";
    this.eventVariable.background = this.middleBackground;
    this.eventVariable.width = this.middleWidth;
    this.eventVariable.fontFamily = this.middleFamily;
    this.eventVariable.fontSize = this.middleFontSize;
    this.eventVariable.color = this.middleColor;
    this.eventVariable.borderWidth = this.middleBorderWidth;
    this.eventVariable.borderColor = this.middleBorderColor;
    this.eventVariable.borderRadius = this.middleBorderRadius;
    this.eventVariable.fontWeight = this.middleFontWeight;
  }

  closePopover() {
    this.popOver.nativeElement.style.display = "none";
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/tabs/dynamic-template.component.ts